import Emittery from 'emittery';

export const emitter = new Emittery();
